import { useResource } from 'json-api-hooks';
import React, { FC } from 'react';

import { EventResource } from '../../models';

import DestroyMenuItem from './DestroyMenuItem';

const EventSignOutMenuItem: FC<{ event: EventResource }> = ({ event }) => {
  const [participant] = useResource({ type: 'participants', id: event.attributes.userParticipantId });

  if (!event.attributes.userParticipantId || !participant) {
    return null;
  }

  return (
    <DestroyMenuItem
      description={`Ben je toch niet in staat om mee te doen aan **${event.attributes.name}**? Meld je dan hier af.`}
      icon="close"
      label="Afmelden"
      resource={participant}
      successMessage="Je bent afgemeld van deze actie"
    />
  );
};

export default EventSignOutMenuItem;
